import { render } from "./ShippingNameForm.vue?vue&type=template&id=34235952"
import script from "./ShippingNameForm.vue?vue&type=script&lang=js"
export * from "./ShippingNameForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__